export default "__VITE_ASSET__C_bu782W__"